import { SimpleEventDispatcher } from "ste-simple-events";
export var ListenLive;
(function (ListenLive) {
    ListenLive["PLAY"] = "play";
    ListenLive["PAUSE"] = "pause";
    ListenLive["PROGRESS"] = "progress";
    ListenLive["ERROR"] = "error";
    ListenLive["ENDED"] = "ended";
    ListenLive["READY"] = "ready";
})(ListenLive || (ListenLive = {}));
export class BaseStorePlayer {
    constructor() {
        Object.defineProperty(this, "externalAction", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: new SimpleEventDispatcher()
        });
    }
}
//# sourceMappingURL=base-player.abstract.js.map